module.exports = __webpack_public_path__ + "static/media/email-notification.9f620dd5.svg";